import React, { memo, forwardRef } from 'react';
import PropTypes from 'prop-types';

import Icon from 'components/commons/Icon';

import { Header, HeaderContent, Title, CloseButton } from './styles';

const ModalSelectHeader = forwardRef(
  ({ title, closeTitle, onClose, children, hidden }, ref) => (
    <Header ref={ref} hidden={hidden}>
      <HeaderContent>
        <Title>{title}</Title>

        <CloseButton type="button" onClickCapture={onClose} title={closeTitle}>
          <Icon name="close" />
        </CloseButton>
      </HeaderContent>

      {children}
    </Header>
  )
);

ModalSelectHeader.propTypes = {
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  closeTitle: PropTypes.string,
  children: PropTypes.node,
  hidden: PropTypes.bool,
};

ModalSelectHeader.defaultProps = {
  closeTitle: '',
  children: null,
  hidden: false,
};

export default memo(ModalSelectHeader);
